var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrueBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0379 11.8011C19.404 11.435 19.404 10.8414 19.0379 10.4753C18.6718 10.1092 18.0782 10.1092 17.7121 10.4753L12.125 16.0624L10.2879 14.2253C9.9218 13.8592 9.3282 13.8592 8.96209 14.2253C8.59597 14.5914 8.59597 15.185 8.96209 15.5511L11.4621 18.0511C11.8282 18.4172 12.4218 18.4172 12.7879 18.0511L19.0379 11.8011Z",
    fill: "#1373E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.825684C6.57867 0.825684 0.5625 6.84186 0.5625 14.2632C0.5625 21.6845 6.57867 27.7007 14 27.7007C21.4213 27.7007 27.4375 21.6845 27.4375 14.2632C27.4375 6.84186 21.4213 0.825684 14 0.825684ZM2.4375 14.2632C2.4375 7.87739 7.61421 2.70068 14 2.70068C20.3858 2.70068 25.5625 7.87739 25.5625 14.2632C25.5625 20.649 20.3858 25.8257 14 25.8257C7.61421 25.8257 2.4375 20.649 2.4375 14.2632Z",
    fill: "#1373E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0379 11.8011C19.404 11.435 19.404 10.8414 19.0379 10.4753C18.6718 10.1092 18.0782 10.1092 17.7121 10.4753L12.125 16.0624L10.2879 14.2253C9.9218 13.8592 9.3282 13.8592 8.96209 14.2253C8.59597 14.5914 8.59597 15.185 8.96209 15.5511L11.4621 18.0511C11.8282 18.4172 12.4218 18.4172 12.7879 18.0511L19.0379 11.8011Z",
    stroke: "#1373E7",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.825684C6.57867 0.825684 0.5625 6.84186 0.5625 14.2632C0.5625 21.6845 6.57867 27.7007 14 27.7007C21.4213 27.7007 27.4375 21.6845 27.4375 14.2632C27.4375 6.84186 21.4213 0.825684 14 0.825684ZM2.4375 14.2632C2.4375 7.87739 7.61421 2.70068 14 2.70068C20.3858 2.70068 25.5625 7.87739 25.5625 14.2632C25.5625 20.649 20.3858 25.8257 14 25.8257C7.61421 25.8257 2.4375 20.649 2.4375 14.2632Z",
    stroke: "#1373E7",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueBlue);
export default __webpack_public_path__ + "static/media/true_blue.7739d59a1499cbff30f99e2707ad4fea.svg";
export { ForwardRef as ReactComponent };